let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7HBHp")).then(() => parcelRequire('7iDk9'));